var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgClip(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 18,
    viewBox: "0 0 19 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.875 16.5C7.595 16.5 5.75 14.655 5.75 12.375V4.5C5.75 2.8425 7.0925 1.5 8.75 1.5C10.4075 1.5 11.75 2.8425 11.75 4.5V10.875C11.75 11.91 10.91 12.75 9.875 12.75C8.84 12.75 8 11.91 8 10.875V5.25H9.5V10.9425C9.5 11.355 10.25 11.355 10.25 10.9425V4.5C10.25 3.675 9.575 3 8.75 3C7.925 3 7.25 3.675 7.25 4.5V12.375C7.25 13.8225 8.4275 15 9.875 15C11.3225 15 12.5 13.8225 12.5 12.375V5.25H14V12.375C14 14.655 12.155 16.5 9.875 16.5Z",
    fill: "#223CDD"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClip);
export default __webpack_public_path__ + "static/media/clip.f544a56bb46f68906f581105331d402f.svg";
export { ForwardRef as ReactComponent };